export default "__VITE_ASSET__8ecf922f__"